import { Injectable } from '@angular/core';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { PageLayoutHandler } from '@spartacus/storefront';
import { combineLatest, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class CartPageLayoutHandler implements PageLayoutHandler {
  constructor(
    protected activeCartService: ActiveCartFacade,
    protected componentService: ComponentService,
    private storageService: StorageService
  ) {}

  handle(slots$: Observable<string[]>, pageTemplate?: string, section?: string) {
    if (pageTemplate === 'CartPageTemplate' && !section) {
      return combineLatest([
        slots$,
        this.activeCartService.getActive(),
        this.activeCartService.isStable(),
        this.componentService.isSavingCart$.pipe(
          startWith(false),
          map((inProgress) => inProgress)
        ),
      ]).pipe(
        map(([slots, cart, cartLoaded, isSavingCart]) => {
          const exclude = (arr: any, args: any) => arr.filter((item: any) => args.every((arg: any) => arg !== item));
          const isRestoringCartSession = this.storageService.getSessionStorageItem('isRestoringCart') === 'true';
          if (!cartLoaded) {
            return exclude(slots, ['TopContent', 'EmptyCartMiddleContent', 'EmptyCartBottomContent']);
          } else {
            if (Object.keys(cart).length === 0 && cartLoaded) {
              return exclude(slots, ['TopContent', 'CenterRightContentSlot']);
            } else {
              if (isSavingCart || isRestoringCartSession) {
                this.storageService.removeSessionStorageItem('isRestoringCart');
                if (cart.totalItems) {
                  return exclude(slots, ['EmptyCartMiddleContent']);
                } else {
                  return exclude(slots, ['TopContent', 'CenterRightContentSlot']);
                }
              } else {
                if (cart.totalItems) {
                  return exclude(slots, ['EmptyCartMiddleContent']);
                } else {
                  return exclude(slots, ['TopContent', 'CenterRightContentSlot']);
                }
              }
            }
          }
        })
      );
    }
    return slots$;
  }
}
